import RouteView from '@/router/RouteView.vue';
import BranchSchool from './index.vue';
import BranchSchoolApply from './apply.vue';
import Courseware from './courseware.vue';

export default [
  {
    path: '/branchSchool',
    name: 'BranchSchool',
    component: RouteView,
    redirect: '/branchSchool/list',
    meta: {
      title: '分校管理',
    },
    children: [
      {
        path: '/branchSchool/list',
        name: 'BranchSchoolList',
        component: BranchSchool,
        meta: {
          title: '管理列表',
        },
      },
      {
        path: '/branchSchool/apply',
        name: 'BranchSchoolApply',
        component: BranchSchoolApply,
        meta: {
          title: '申请分校',
        },
      },
      {
        path: '/branchSchool/edit/:id',
        name: 'BranchSchoolEdit',
        component: BranchSchoolApply,
        meta: {
          title: '校区信息编辑',
        },
      },
      {
        path: '/branchSchool/courseware/:id',
        name: 'Courseware2',
        component: Courseware,
        meta: {
          title: '授权课件',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/BranchSchool/index.js